<div class="menu" [ngClass]="{'expanded-bar': isSlideBarExpanded}">
	<div class="menu-item-container">
		<ng-container *ngFor="let menuItem of menu;">
			<div class="menu-line-item"
				(click)="navigateTo (menuItem)"
				*ngIf="menuItem.isVisible"
				[ngClass]="{'active-menu-item': activeLink === menuItem.newurl}"
			>
				<img [src]="menuItem.icon" class="{{menuItem.newurl}}" alt="">
				<div class="title" *ngIf="isSlideBarExpanded">{{menuItem.title}}</div>
			</div>
		</ng-container>
	</div>
	
	<div class="expand-bar-button" (click)="expandSlideBar()" [ngClass]="{'collapse-bar-button': isSlideBarExpanded}">
		<img *ngIf="!isSlideBarExpanded" src="../../../assets/images/arrows/right-arrow.svg" alt="">
		<img *ngIf="isSlideBarExpanded" src="../../../assets/images/arrows/right-arrow.svg" alt="">
	</div>
</div>
